//const apiLink = 'http://localhost:3000/'

/* ETHEN SYSTEM */

// ETHEN STOP USING THIS
// const apiLink = 'https://localhost:7071/api'
// ETHEN STOP USING THIS
// const frontendRoot = 'http://localhost:8080'
// ETHEN STOP USING THIS

/* ETEINNE's DEV SYSTEM */
//const apiLink = 'https://localhost:7071/api'
//const frontendRoot = 'http://localhost:8080'

/* TEST SYSTEM */

//const apiLink = 'http://d19ca-00138473:7071/api'
//const frontendRoot = 'http://d19ca-00138473:83'

/* .env method */
const apiLink = process.env.VUE_APP_APILINK
const frontendRoot = process.env.VUE_APP_FRONTENDROOT

export { apiLink , frontendRoot}
